import { OrderApi } from '@/api/order.api';
import { ArrayCreateGenericViability, CreateGenericViability } from '@/models/proposal-order.model';
import { LoadingService } from '@/services/loading.service';
import { NotificationService } from '@/services/notification.service';
import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Router } from '@angular/router';

export interface DialogData {
  proposalID: string;
  researchViabilityArray: CreateGenericViability[];
  inventoryViabilityArray: CreateGenericViability[];
  restockingViabilityArray: CreateGenericViability[];
  companyOperation: any[];
}

@Component({
  selector: 'app-dialogViability',
  templateUrl: './dialogViability.component.html',
  styleUrls: ['./dialogViability.component.scss'],
})
export class DialogViabilityComponent {

  form!: FormGroup;
  companyOperation: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogViabilityComponent>,
    private formBuilder: FormBuilder,
    private orderApi: OrderApi,
    private notificationService: NotificationService,
    private loadingService: LoadingService,
    private router: Router
  ) {
    this.initializeForm();
    this.companyOperation = this.data.companyOperation;
  }

  onRightButton() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  keypressDate(event: KeyboardEvent) {
    event.preventDefault();
    return;
  }

  noInputValidator(control: AbstractControl): ValidationErrors | null {
    return control.value ? { noInputAllowed: true } : null;
  }

  private initializeForm() {
    this.form = this.formBuilder.group({
      suggestedStartDate: [null, [Validators.required]],
      reasonInfeasibility: [null, [Validators.required]],
      viability: [false],
      operationCompany: [null, [Validators.required]]
    });

    let viability = this.form.get('viability')!.value;
    this.updateFieldStates(this.form, viability);

    this.form.get('viability')!.valueChanges.subscribe((viability: any) => {
      this.updateFieldStates(this.form, viability);
    });
  }

  updateViabilities(form: FormGroup) {
    this.loadingService.show();

    const newValues = {
      suggestedStartDate: form.get('suggestedStartDate')!.value,
      reasonInfeasibility: form.get('reasonInfeasibility')!.value,
      viability: form.get('viability')!.value,
      operationCompany: form.get('operationCompany')!.value
    };

    if (this.data?.researchViabilityArray) {
      this.data?.researchViabilityArray.forEach((store: any) => {
        store.suggestDate = newValues.suggestedStartDate;
        store.reasonInfeasibility = newValues.reasonInfeasibility;
        store.viability = newValues.viability;
        store.operationCompany = newValues.operationCompany;
      });
    }
    if (this.data?.inventoryViabilityArray) {
      this.data?.inventoryViabilityArray.forEach((store: any) => {
        store.suggestDate = newValues.suggestedStartDate;
        store.reasonInfeasibility = newValues.reasonInfeasibility;
        store.viability = newValues.viability;
        store.operationCompany = newValues.operationCompany;
      });
    }
    if (this.data?.restockingViabilityArray) {
      this.data?.restockingViabilityArray.forEach((store: any) => {
        store.suggestDate = newValues.suggestedStartDate;
        store.reasonInfeasibility = newValues.reasonInfeasibility;
        store.viability = newValues.viability;
        store.operationCompany = newValues.operationCompany;
      });

      const newDataViability = new ArrayCreateGenericViability(
        this.data.researchViabilityArray,
        this.data.inventoryViabilityArray,
        this.data.restockingViabilityArray
      );

      this.orderApi.createViability(this.data.proposalID, newDataViability).then(() => {
        this.loadingService.hide();
        this.onRightButton();
        this.notificationService.showSuccessMessage('Viabilidades atualizadas com sucesso!');
      }).catch(() => {
        this.loadingService.hide();
        this.notificationService.showErrorMessages(['Erro ao atualizar viabilidades!']);
      });
    }
  }

  massEdit() {
    this.updateViabilities(this.form);

  }

  isSaveUpdateButtonEnabled(): boolean {

    if (this.form.invalid) {
      return false;
    } else {
      return true;
    }
  }

  private updateFieldStates(formGroup: FormGroup, viability: boolean) {
    if (viability) {
      formGroup.get('reasonInfeasibility')!.disable();
      formGroup.get('reasonInfeasibility')!.disable();
      formGroup.get('operationCompany')!.enable();
      formGroup.get('suggestedStartDate')!.enable();
    } else {
      formGroup.get('reasonInfeasibility')!.enable();
      formGroup.get('operationCompany')!.disable();
      formGroup.get('operationCompany')!.setValue(null);
      formGroup.get('suggestedStartDate')!.disable();
    }
  }
}
